function findPathWithConcreteEndNode([startNode, endNode], relations) {
    var _a;
    const path = [endNode];
    while (path[0] !== startNode) {
        const lastNode = path[0];
        const { parentId = null } = (_a = relations[lastNode]) !== null && _a !== void 0 ? _a : {};
        if (parentId === null) {
            break;
        }
        path.unshift(parentId);
    }
    return path;
}
function getDescendantsAsIds(id, relations, key) {
    const { [id]: relation } = relations;
    switch (key) {
        case 'connections':
            return relation.connections.map(({ id, connection }) => connection || id);
        case 'children':
            return relation.children;
    }
}
function getDescendantsForId(id, relations, key) {
    if (!id || !relations[id]) {
        return [];
    }
    const descendants = getDescendantsAsIds(id, relations, key);
    return descendants.reduce((acc, id) => {
        acc.push(id, ...getDescendantsForId(id, relations, key));
        return acc;
    }, []);
}
function findAllDescendants(startNode, relations, key) {
    return startNode
        ? [startNode, ...getDescendantsForId(startNode, relations, key)]
        : [];
}
export function getNodesInPath([nodeA, nodeB], relations, key = 'children') {
    const path = nodeB
        ? findPathWithConcreteEndNode([nodeA, nodeB], relations)
        : findAllDescendants(nodeA, relations, key);
    return path;
}
